module.exports = __webpack_public_path__ + "static/media/Huis-4-2.2229cc46.jpg";